<template>
    <div class="muven-container">
        <div class="muven-router-name-container">
            <p class="muven-router-name">Arquivos do relatório</p>
        </div>

        <div class="muven-content">
            <Breadcrumb :items="breadcrumbList" class="mb-3"/>

            <Loading page v-if="loading" />        

	    <ReportGeneratorFilterCmp 
	    	ref="reportGeneratrorFilterCmp"
		@submit="generateReportFile" />

            <div class="mb-3" v-if="!loading">
                <div>
                    <button type="button" 
                        class="btn btn-primary"
			v-show="!report.hasFilter()"
			:disabled="generatingReportFile"
                        @click="generateReportFile()">
                        Gerar

			<Loading v-show="generatingReportFile" />
                    </button>

                    <button type="button" 
                        class="btn btn-primary"
			v-show="report.hasFilter()"
			:disabled="generatingReportFile"
                        @click="openFilterModal()">
                        Gerar

			<Loading v-show="openingFilterModal" />
                    </button>

                    <button type="button" 
                        class="btn btn-outline-secondary ml-3"
			:disabled="updatingReportFileList"
                        @click="updateReportFileList()">
                        Atualizar

			<Loading v-show="updatingReportFileList" />
                    </button>
                </div>
            </div>

            <NothingFound v-if="nothingToShow" />

            <div v-if="!loading && !nothingToShow">
                <div class="table-responsive">
                    <table class="table table-sm table-hover table-striped">
                        <thead>
                            <tr>
                                <th>Arquivo</th>
                                <th>Criado em</th>
                                <th>Expira em</th>
				<th>Status</th>
				<th>Ação</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="(reportFile, index) in reportFileList" :key="index">
                                <td>{{reportFile.filename}}</td>
                                <td>{{reportFile.createdAt | dateTimeFilter}}</td>
                                <td>{{reportFile.expirationAt | dateTimeFilter}}</td>
				<td>
				    <span class="muven-td-icon">
                                        <fa icon="check-circle" 
                                            v-if="reportFile.isStatusProcessed()"
                                            class="text-success" />

                                        <fa icon="window-close" 
                                            v-if="reportFile.isStatusError()"
                                            class="text-danger" />

                                        <fa icon="hourglass-half" 
                                            v-if="reportFile.isStatusAwaiting()"
                                            class="text-muted" />
                                    </span>
                                    <span>{{reportFile.getStatusDescription()}}</span>
				</td>
				<td>
					<span v-show="reportFile.isStatusProcessed()">
						<a class="btn btn-sm btn-outline-secondary"
							:href="reportFile.url"
							target="_blank">
							Baixar
						</a>
					</span>
					<span v-show="!reportFile.isStatusProcessed()">-</span>
				</td>
			     </tr>
			</tbody>
		    </table>
		</div>
	     </div>		
	</div>
    </div>
</template>

<script>
import reportService from '@/report/services/ReportService'
import {infoOrPlaceholder} from '@/utils/filters/InformationOrPlaceholderFilter'
import {dateTimeFilter} from '@/utils/filters/DateTimeFilter'
import ModalService from '../../utils/services/ModalService'
import { ReportModel } from '../models/ReportModel'
import ReportGeneratorFilterCmp from '../components/ReportGeneratorFilterCmp.vue'

const ID_REPORT_FILE_CREATION_MODAL = '#muven-report-file-creation-modal'

export default {
	name: 'ReportFileListView',
	components: {
		ReportGeneratorFilterCmp,
	},
	filters: {
		infoOrPlaceholder,
		dateTimeFilter,
	},
	data() {
		return {
			loading: true,
			reportId: null,
			generatingReportFile: false,
			openingFilterModal: false,
			updatingReportFileList: false,
			report: new ReportModel(),
			reportFileList: [],
			breadcrumbList: [
				{
					id: 0,
					path: '/relatorios',
					description: 'Relatórios',
				},
				{
					id: 1,
					path: '',
					description: 'Arquivos do relatório'
				},
			],
		}
	},
	methods: {
		async generateReportFile(filterForm) {
			this.generatingReportFile = true

			try {
				const newFile = await reportService.generateReportFile(this.report.getId(), filterForm)

				if (this.report.hasFilter()) {
					this.closeFilterModal()
				}

				this.reportFileList.unshift(newFile)
				
				this.$floatingAlert.info({
					title: '',
					message: 'O arquivo já está sendo processado. Assim que estiver pronto para uso, lhe enviaremos uma notificação.',
				})
			} catch(err) {
				this.$floatingAlert.error({
					message: err.message,
				})
			}

			this.generatingReportFile = false
		},
		async updateReportFileList() {
			this.updatingReportFileList = true

			try {
				this.reportFileList = await reportService.getReportFileList(this.report.getId())
			} catch (err) {
				this.$floatingAlert.error({
					message: err.message,
				})
			}

			this.updatingReportFileList = false
		},
		async showReportFileCreationModal() {
			await ModalService.show(ID_REPORT_FILE_CREATION_MODAL)
		},		
		openFilterModal() {
			this.$refs.reportGeneratrorFilterCmp.show(this.report)
		},
		closeFilterModal() {
			this.$refs.reportGeneratrorFilterCmp.close()
		},
		_updateBreadcrumbReportInfo() {
			this.breadcrumbList[1].description = `Arquivos do relatório: ${this.report.name}`;
		},
	},
	async mounted() {
		try {
			this.report = await reportService.getReportById(this.$route.params.id)
			this.reportFileList = await reportService.getReportFileList(this.report.getId())
			this._updateBreadcrumbReportInfo()
			this.loading = false
		} catch (err) {
			this.$floatingAlert.error({
				message: err.message,
			})
		}
	},
	computed: {
		nothingToShow() {
			return !this.loading && !this.reportFileList.length
		},
	},
}
</script>